import { Container } from '@bit/ui-common.ui-components/ss-components';
import FtttfLayout from '../components/layouts/FtttfLayout';
import { ssSessionUtils } from '@bit/ui-common.ui-components/ss-utils';
const { htmlStorage } = ssSessionUtils;

export default Container({ state: s => ({...s}), services: [] }, 
class Ftttf extends React.Component {
    constructor(props) { 
        super(props); 
        window.session = htmlStorage().get('ssSession');
    }
    render = () => <FtttfLayout {...this.props} />
})